module.exports = __webpack_public_path__ + "img/notStandrard.7544aead.png";